import useSpaces from '@/composables/space/spaces';
import { computed } from 'vue';
import { findInArray } from 'shared/lib/array/array';
import { isEmpty } from 'lodash-es';
import { useI18n } from 'vue-i18n';

export default function useSpaceFormValidator(space) {
  const { t } = useI18n();
  const spacesSvc = useSpaces();
  const titleIsEmpty = computed(() => isEmpty(space.value.title.trim()));
  const titleAlreadyExists = computed(() => {
    const otherTeam = findInArray({ haystack: spacesSvc.allSpaces.value, needle: space.value.title, key: 'title' });
    return otherTeam !== null && otherTeam.uid !== space.value.uid;
  });

  const formIsValid = computed(() => !titleIsEmpty.value && !titleAlreadyExists.value);
  const formValidationHint = computed(() => {
    if (formIsValid.value === true) {
      return '';
    }
    if (titleIsEmpty.value === true) {
      return t('spaceEditor.validation.titleIsEmpty');
    }
    if (titleAlreadyExists.value === true) {
      return t('spaceEditor.validation.titleAlreadyExists');
    }
    return '';
  });
  return { titleIsEmpty, titleAlreadyExists, formIsValid, formValidationHint };
}
